import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {

    setLocalStorage(name, value): any {
      localStorage.setItem(name, value);
    }

    deleteStorage(name) {
      localStorage.removeItem(name);
    }

    clearStorage(){
      localStorage.clear();
    }
    getLocalStorage(name): any {
      return localStorage.getItem(name);
    }
}
